import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setIsSuggesting')(function setIsSuggesting(
    viewState: AtMentionsViewState,
    isSuggesting: boolean,
    queryString: string = ''
) {
    viewState.isSuggesting = isSuggesting;
    viewState.isPopupShown = isSuggesting;

    if (!isSuggesting) {
        // Reset the viewState
        viewState.queryString = '';
        viewState.isSearching = false;
        viewState.hasSearchedDirectory = false;
    }
});
